import type { HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { isElement } from 'react-is';
import { twMerge } from 'cn';
import type { HeadingProps } from './types.js';

/** `<Heading>` component. */
export const Heading = ({ className, subtitle, title, ...props }: HeadingProps): ReactElement => (
  <div className={twMerge('flex flex-col gap-2', className)} {...props}>
    {isElement(title) ? title : <Heading.Title>{title}</Heading.Title>}
    {isElement(subtitle) ? subtitle : <Heading.Subtitle>{subtitle}</Heading.Subtitle>}
  </div>
);

Heading.Title = function Title({
  children,
  className,
  ...props
}: HtmlAttributesWithChildren): ReactElement {
  return (
    <h2 className={twMerge('mb-0 font-medium', className)} {...props}>
      {children}
    </h2>
  );
};

Heading.Subtitle = function Subtitle({
  children,
  className,
  ...props
}: HtmlAttributesWithChildren): ReactElement {
  return (
    <p className={twMerge('text-sm text-muted', className)} {...props}>
      {children}
    </p>
  );
};
